import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a6d7b539c5bc0024008b63865134fd330b from "./generated-b43b337e-28f4-4beb-89f1-cfe726eb83f1.json";

import afd72eccfc05d22ae468880b5519d9239b from "./generated-04e37333-fd5f-40bc-bd79-c4a5dd97f359.json";

import a2aa11f89944c843554630fb590680965b from "./generated-9dbf98db-b63d-4948-9ae6-ce9313384a5d.json";

import a01d5f349c4d3e11454729a3353e953cfb from "./generated-02e5ab0b-c9fb-4013-8a76-08a75861ca58.json";

import a85f15465cc56777d46783ac0f5118227b from "./generated-264bef62-7cbb-4ce4-ac0c-9a76ca42c745.json";

import a37f740ceb1a0cfe4c98e0754b33d78a1b from "./generated-f8bbcede-075b-4cae-8a28-8c51df3f64a6.json";

import a08deb1d6caac6b82bc0ebb938614446db from "./generated-fd4677fa-0576-4a60-9faa-7ab7f474cfc5.json";

import a7695734f15879ba5a76876dc15974364b from "./generated-7e2429e1-c98c-4400-9484-201887c69a6a.json";

import a37b0bd53d25e48868ce9e56de038c0b4b from "./generated-23827ee5-41c4-46bb-a3d5-3b91edc7e249.json";

import a594f710161fd8a1e11a2e00f24f6a054b from "./generated-c66d5c7c-beb0-4351-a6fd-ce0b956cb299.json";

import ae7f0532c0fc333e92bd553fccb1829dab from "./generated-f0de9d0b-3daa-4542-a233-344a575b4566.json";

import a91b95376a4e013ef82b6b379a22dd18cb from "./generated-2cbd4cdf-dea1-490f-a2c9-d3c9c8294bff.json";

import a5fb134b28110278e38665fc0b609945cb from "./generated-1478a718-539c-4b83-8e09-a41b8c966560.json";

import a552a80d111c707171fac76f996120e8cb from "./generated-cd089775-f975-4032-b09b-13fa5c54a9b9.json";

import acb0f1aee4b758ac217655f5b3e96edb8b from "./generated-d07344bd-b887-46b1-8d0d-1de549f4c535.json";

import a9383a4ff17b363abada60f403cba777fb from "./generated-0b164e5c-da56-4d97-be93-32c2760dbda9.json";

import a5617d669b5a8e8529b80151f07527cbbb from "./generated-3ed0c500-a2de-4d68-bce4-0228c4f4ad0f.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a6d7b539c5bc0024008b63865134fd330b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(afd72eccfc05d22ae468880b5519d9239b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a2aa11f89944c843554630fb590680965b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a01d5f349c4d3e11454729a3353e953cfb);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a85f15465cc56777d46783ac0f5118227b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a37f740ceb1a0cfe4c98e0754b33d78a1b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a08deb1d6caac6b82bc0ebb938614446db);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a7695734f15879ba5a76876dc15974364b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a37b0bd53d25e48868ce9e56de038c0b4b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a594f710161fd8a1e11a2e00f24f6a054b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(ae7f0532c0fc333e92bd553fccb1829dab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a91b95376a4e013ef82b6b379a22dd18cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a37b0bd53d25e48868ce9e56de038c0b4b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a5fb134b28110278e38665fc0b609945cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a552a80d111c707171fac76f996120e8cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a37b0bd53d25e48868ce9e56de038c0b4b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(acb0f1aee4b758ac217655f5b3e96edb8b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a9383a4ff17b363abada60f403cba777fb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a5617d669b5a8e8529b80151f07527cbbb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(acb0f1aee4b758ac217655f5b3e96edb8b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */